import Toast from './Toast';
// import crypto from 'crypto';

const getInitial = (name = ''): any =>
    name
        .replace(/\s+/, ' ')
        .split(' ')
        .slice(0, 2)
        .map((v) => v && v[0].toUpperCase())
        .join('');

const handleErrorResponse = (error: any): void => {
    if (error && error.response) {
        const { data, status } = error.response;
        if (status === 400) {
            const { msg } = data;
            Toast.showErrorMessage(msg);
        } else if (status === 500) {
            Toast.showErrorMessage('Please try again');
        }
    }
};

const handleSuccessResponse = (response: any): any => {
    const { msg } = response.data;
    Toast.showSuccessMessage(msg);
};

const titleCase = (value: string): any => {
    if (value) {
        return value
            .trim()
            .split(' ')
            .map((w) =>
                w !== ''
                    ? w[0].toUpperCase() + w.substring(1).toLowerCase()
                    : ''
            )
            .join(' ');
    }
    return '';
};

const fileExtension = (fileName: string): string => {
    if (fileName) {
        const url = fileName.split('?')[0];
        const extension = url.split('.').pop();
        return extension || '';
    }
    return '';
};

const isPDFDocument = (documentUrl: string): boolean =>
    fileExtension(documentUrl) === 'pdf';

const getFileType = (file: any): any =>
    file.type === 'application/pdf' ? 'pdf' : 'image';

const getFileFromBlobUrl = (blobUrl: any): Promise<any> =>
    fetch(blobUrl).then((r) => r.blob());

const convertBase64ToFile = (base64: string): Promise<any> =>
    new Promise((resolve, reject) => {
        fetch(base64)
            .then((res) => res.blob())
            .then((blob) => {
                const file = new File([blob], 'sign.png', {
                    type: 'image/png',
                });
                resolve(file);
            })
            .catch((error) => {
                reject(error);
            });
    });

const convertFileToBase64 = (file: any): Promise<any> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.onerror = (error) => {
            reject(error);
        };
    });

const convertBase64SVGToBase64Jpeg = (
    svgReference: string,
    base64: string
): Promise<any> =>
    new Promise((resolve, reject) => {
        try {
            const svgNode: any = document.getElementById(svgReference);
            const width = svgNode.width.baseVal.value * 3;
            const height = svgNode.height.baseVal.value * 3;
            const image = new Image();
            image.onload = () => {
                const canvas: any = document.getElementById('svg-canvas');
                const context: any = canvas.getContext('2d');
                canvas.width = width;
                canvas.height = height;
                context.clearRect(0, 0, width, height);
                context.drawImage(image, 0, 0, width, height);
                const imageUrl = canvas.toDataURL();
                resolve(imageUrl);
            };
            image.src = base64;
        } catch (error) {
            reject(error);
        }
    });

const convertSVGToImage = (svgReference: string): string => {
    const svgNode: any = document.getElementById(svgReference);
    const s = new XMLSerializer().serializeToString(svgNode);
    return `data:image/svg+xml;base64,${decodeURI(encodeURIComponent(s))})}`;
};

const appendBlobURL = (files: File[]): File[] =>
    files.map((file) =>
        Object.assign(file, {
            preview: URL.createObjectURL(file),
        })
    );

const getFileTypeFromUrl = (url: any): any => {
    const baseUrl = url.split('?')[0];
    const extension = baseUrl.split('.').pop();
    return extension === 'pdf' ? 'pdf' : 'image';
};

const getFileName = (fileName: any): any => fileName.split('.')[0];

const truncateLast = (str: any): string => {
    if (str.length > 30) {
        return `${str.substr(0, 30)}...`;
    }
    return str;
};

const truncateMiddle = (str: any): any => {
    if (str.length > 35) {
        return `${str.substr(0, 15)}...${str.substr(
            str.length - 15,
            str.length
        )}`;
    }
    return str;
};

const fileNameFromURL = (fileURL: string): string => {
    const url = fileURL.split('?')[0];
    const fileName = url.split('/').pop();
    return fileName !== undefined ? fileName : 'Default.pdf';
};

export default {
    handleSuccessResponse,
    handleErrorResponse,
    titleCase,
    getInitial,
    fileExtension,
    isPDFDocument,
    getFileFromBlobUrl,
    getFileType,
    convertBase64ToFile,
    convertSVGToImage,
    convertBase64SVGToBase64Jpeg,
    convertFileToBase64,
    appendBlobURL,
    getFileTypeFromUrl,
    getFileName,
    truncateLast,
    truncateMiddle,
    fileNameFromURL,
};
